export const heading = {
  en: "HealthVaani",
  hi: "हेल्थवाणी",
  or: "ହେଲଥବାଣୀ"
};

export const secondaryHeading = {
  en: "A Chatbot to answer your work queries",
  hi: "आपके काम संबंधी प्रश्नों का उत्तर देने के लिए एक चैटबॉट",
  or: "A Chatbot to answer your work queries"
};

export const description = {
  en: "Thank you so much for your participation. Our team will get back to you if you are selected for pilot activity.",
  hi: "आपकी भागीदारी के लिए बहुत बहुत धन्यवाद. यदि आप पायलट गतिविधि के लिए चुने जाते हैं तो हमारी टीम आपसे संपर्क करेगी।",
  or: "Thank you so much for your participation. Our team will get back to you if you are selected for pilot activity."
};

export const guideButtons = {
  next: {
    en: "Next",
    hi: "आगे जाएँ",
    or: "ପରବର୍ତ୍ତୀ"
  },
  previous: {
    en: "Previous",
    hi: "पीछे जाएं",
    or: "ପୂର୍ବ"
  },
  skip: {
    en: "Skip",
    hi: "स्किप करें",
    or: "ଛାଡିଦିଅନ୍ତୁ"
  },
  stop: {
    en: "Click to stop",
    hi: "रोकने के लिए क्लिक करें",
    or: "ବନ୍ଦ କରିବାକୁ କ୍ଲିକ୍ କରନ୍ତୁ"
  }
};

export const langPreferenceConstantGuide = {
  en: "Thank you for your participation",
  hi: "आपकी भागीदारी के लिए बहुत बहुत धन्यवाद.",
  or: "Thank you for your participation"
};
